import { createContext, useContext } from "react";
import {
  DEFAULT_TENANT_THEME_PREFS,
  type TenantThemeColorMode,
  type TenantThemeDensity,
  type TenantThemeFontScale,
} from "@shared/schema";

export interface ThemeContextValue {
  prefs: {
    primaryColor: string | null;
    accentColor: string | null;
    density: TenantThemeDensity;
    fontScale: TenantThemeFontScale;
    colorMode: TenantThemeColorMode;
  };
  effectiveMode: "light" | "dark";
  densityMultiplier: number;
}

export const ThemeContext = createContext<ThemeContextValue>({
  prefs: { ...DEFAULT_TENANT_THEME_PREFS },
  effectiveMode: "light",
  densityMultiplier: 1,
});

export function useTheme(): ThemeContextValue {
  return useContext(ThemeContext);
}
